/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Consent_TitleInputs */

const en_of_landing_consent_title = /** @type {(inputs: Of_Landing_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations on your terms`)
};

const id_of_landing_consent_title = /** @type {(inputs: Of_Landing_Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percakapan atas pilihanmu`)
};

/**
* | output |
* | --- |
* | "Conversations on your terms" |
*
* @param {Of_Landing_Consent_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_consent_title = /** @type {((inputs?: Of_Landing_Consent_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Consent_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_consent_title(inputs)
	return en_of_landing_consent_title(inputs)
});